import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { Grid, Button } from "@mui/material";
import { Title } from "react-admin";
import { Fragment } from "react";
import { RowEffect } from "../Partials/RowEffect";
import { tenants } from "utils/tenants";
import { settings } from "app";
import { CitizenshipIds } from "utils/constants";

const OthersOptions = () => {
  const navigate = useNavigate();

  const btnData = [
    // { id: 1, name: `По ПМС 103 или 228 за Българи`, url: "/candidate/bg/pms", citizenshipId: 1 },
    {
      id: 2,
      tenancies: [tenants.MU, tenants.MGU],
      name: `Прехвърлени от друг университет за Българи`,
      url: "/candidate/bg/other-uni",
      citizenshipId: CitizenshipIds.Bulgarians,
    },
    {
      id: 5,
      tenancies: [tenants.MU],
      name: `Прехвърлени от друг университет за Чужденци`,
      url: "/candidate/en/other-uni",
      citizenshipId: CitizenshipIds.EuForeigners,
    },
    {
      id: 3,
      tenancies: [tenants.MU, tenants.MGU],
      name: `С индивидуална заповед за Българи`,
      url: "/candidate/bg/individual",
      citizenshipId: CitizenshipIds.Bulgarians,
    },
    {
      id: 6,
      tenancies: [tenants.MU],
      name: `С индивидуална заповед за Чужденци`,
      url: "/candidate/en/individual",
      citizenshipId: CitizenshipIds.EuForeigners,
    },
    {
      id: 4,
      tenancies: [tenants.MU],
      name: `По ПМС 103 или 228 за Чужденци`,
      url: "/candidate/en/pms",
      citizenshipId: CitizenshipIds.EuForeigners,
    },
  ];
  return (
    <>
      <Title title="Записване на други студенти" />
      <Grid
        container
        spacing={2}
        paddingTop={4}
        paddingX={6}
        gap={2}
      >
        <RowEffect title="Изберете критерий за записване на студент" />

        {btnData.map((option, idx) =>
          !option.tenancies || option.tenancies.some(tenant => tenant === settings.tenant) ? (
            <Fragment key={`btn-${idx}`}>
              {option.id === 4 && (
                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={4}
                  sx={{
                    display: "block",
                    margin: "0 auto",
                  }}
                  key={option.id}
                ></Grid>
              )}
              <Grid
                item
                xs={12}
                md={6}
                xl={4}
                sx={{
                  display: "block",
                  margin: "0 auto",
                }}
                key={`idx-${option.id}`}
              >
                <Button
                  variant="contained"
                  fullWidth
                  color="secondary"
                  startIcon={<AddIcon />}
                  sx={{
                    color: "#fff",
                    padding: ".7rem",
                    boxShadow: "0.5em 0.5em  #ffffff22, 0.5em 0.5em  .4em rgba(47, 45, 52, 0.33)",
                  }}
                  onClick={() =>
                    navigate(option.url, {
                      state: { citizenshipId: option.citizenshipId },
                    })
                  }
                >
                  {settings.tenant === tenants.MGU ? option.name.replace(" за Българи", "") : option.name}
                </Button>
              </Grid>
            </Fragment>
          ) : null,
        )}
        <RowEffect />
      </Grid>
    </>
  );
};
export default OthersOptions;
